export const initialMsgOutFilterMap = {
    clearance: {
        wilco: true,
        roger: true,
        sent: true,
        cancel: true,
    },
    comms: {
        wilco: true,
        sent: true,
        held: true,
        cancel: true,
    },
    info: {
        roger: true,
        sent: true,
        closed: true,
        cancel: true,
    },
};
//# sourceMappingURL=msgOutFilter.js.map